import React, { useState } from 'react';
import { useTheme, createUseStyles } from 'react-jss';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import Icon from '@mdi/react';
import * as R from 'ramda';
import { useHistory } from 'react-router';

import { mdiShareVariantOutline } from '@mdi/js';

import Container from '@components/Container';
import ShareModal from '@modules/Modal/ShareModal';

import { lockScroll } from '@utils/ui';
import { trunc } from '@utils/tools';

const useStyles = createUseStyles(({
  rem,
}) => ({
  root: {
    width: '100%',
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    padding: [rem(10), rem(20)],
    color: 'rgba(0, 0, 0, 1)',
    backgroundColor: 'rgba(0, 0, 0, .05)',
  },
  title: {
    fontSize: rem(18),
  },
  icon: {
    color: 'rgba(0, 0, 0, 1)',
  },
  intro: {
    fontSize: rem(14),
    marginTop: rem(20),
    lineHeight: '25px',
    letterSpacing: '1px',
  },
  chain: {
    height: rem(80),
    margin: [rem(10), 0],
  },
  left: {
    width: '60%',
    border: '1px solid rgba(87, 188, 249, 1)',
    backgroundColor: 'rgba(87, 188, 249, 1)',
    padding: [rem(5), rem(10)],
    borderRadius: rem(8),
    '& > img': {
      borderRadius: '50%',
    }
  },
  content: {
    overflow: 'hidden',
    color: 'rgba(255, 255, 255, 1)',
    '& > span': {
      marginLeft: rem(10),
      padding: [rem(5), 0],
      display: 'block',
      fontSize: rem(10),
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
      overflow: 'hidden',
      wordBreak: 'break-all',
      '&:first-child': {
        fontSize: rem(14),
      },
      '&:last-child': {
        maxWidth: `${rem(160)}`,
        padding: rem(5),
        borderRadius: rem(5),
        color: 'rgba(0, 0, 0, 1)',
        backgroundColor: 'rgba(255, 255, 255, 1)',
      },
    }
  },
  right: {
    '& > span': {
      color: 'rgba(87, 188, 249, 1)',
      marginBottom: 10,
      fontSize: rem(12),
    }
  },
}), {
  name: 'BasicInfo'
})

const BasicInfo = (props) => {
  const theme = useTheme();
  const router = useHistory();
  const classes = useStyles(theme);
  const { t, data, language } = props;
  const [openShare, setOpenShare] = useState(false);

  const handleOpenShare = () => {
    setOpenShare(true);
    lockScroll();
  }

  const handleGotoChain = () => {
    router.push(`/chain`);
  }

  const skuData = R.pathOr({}, ['jsonData', 'sku'])(data);
  const base = R.pathOr({}, ['base'])(skuData);
  const vid = R.pathOr('', ['vid'])(data);

  return (
    <Container className={classNames(classes.root)}>
      <Container
        flex
        justify='space-between'
        alignItems='center'
        style={{ width: '100%', marginTop: 16 }}
      >
        <span className={classes.title}>{base.productname || ''}</span>
        <Icon
          size={0.4}
          onClick={handleOpenShare}
          path={mdiShareVariantOutline}
          className={classNames(classes.icon)}
        />
      </Container>
      <span className={classes.intro}>{base.description || ''}</span>

      <Container
        flex
        alignItems='center'
        justify='space-between'
        className={classes.chain}
      >
        <Container
          flex
          direction='row'
          alignItems='center'
          className={classes.left}
          onClick={() => handleGotoChain()}
        >
          <img
            src="./static/images/products/evidence.png"
            alt="icon"
            height={40}
            width={40}
          />
          <div className={classes.content}>
            <span>{t('fashion')}</span>
            <span>{t('voucher')}</span>
            <span>{trunc(vid, 8, 10)}</span>
          </div>
        </Container>
        <Container
          flex
          direction='column'
          className={classes.right}
        >
          <span>Powered by</span>
          <img
            src="./static/images/logo_vechain.png"
            alt="logo"
            width={85}
          />
        </Container>
      </Container>

      {
        openShare && (
          <ShareModal
            t={t}
            language={language}
            setOpenShare={setOpenShare}
          />
        )
      }
    </Container>
  )
};

BasicInfo.propTypes = {
  t: PropTypes.func.isRequired,
  data: PropTypes.object.isRequired,
  language: PropTypes.string.isRequired,
}

export default BasicInfo;
